




























































































































































































































import { snakeCase } from 'lodash'
import { Component, Mixins, Prop, PropSync, Watch } from 'vue-property-decorator'

import {
  ActivationActionMixin,
  getFlowActionTemplate,
  getMessageActionTemplate,
  UserActivationAction,
  UserActivationActionTypeEnum
} from '.';
import ModelSetter from '../../../../Mixins/ModelSetter'
import AListCustom from "../../../../components/AListCustom/AListCustom.vue";
import AListCustomItem from "../../../../components/AListCustom/AListCustomItem.vue";
import ConfigField from '../../../../components/ConfigField/ConfigField.vue'
import CreateIfEmpty from '../../../../components/CreateIfEmpty.vue'
import { PlaceholdersOnes, PlaceholdersStack } from '../../../../components/Editor/components/Toolbar/types'
import {
  AvailableButtonsTypes,
} from "../../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types";
import MultiMessageEditorWithMediaInput
  from '../../../../components/Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import SelectInput from '../../../../components/Pi/fields/SelectInput/SelectInput.vue'
import { SelectOptionData } from '../../../../components/Pi/types'
import { warningNotificationWrapper } from '../../../../logic/helpers/NotificationService';
import { SelectOption } from "../../../../logic/types";
import { BindTargetByCode, BindTargetByCodeRes } from '../../../types/BindTarget.types';
import { VueComponent } from "../../../types/VueComponent";
import FeedbackBindGroupId from '../PrivateMessageSettings/components/FeedbackBindGroupId.vue'
import BotFeedbackLimitAlert from "../components/Limitations/BotFeedbackLimitAlert.vue";
import BotFeedbackLimitsMixin from "../components/Limitations/BotFeedbackLimitsMixin";

type ActionType = UserActivationActionTypeEnum | 'none' | 'group' | 'admin'

@Component({
  components: {
    AListCustomItem, AListCustom,
    BotFeedbackLimitAlert,
    CreateIfEmpty,
    MultiMessageEditorWithMediaInput,
    SelectInput,
    FeedbackBindGroupId,
    ConfigField,
  },
  data() {
    return {
      UserActivationActionTypeEnum,
    }
  },
  methods: {
    warningNotificationWrapper
  }
})
export default class ActivationActionData extends Mixins(ModelSetter, BotFeedbackLimitsMixin, ActivationActionMixin) {
  @PropSync('activationAction') action!: UserActivationAction | null

  @PropSync('groupId') feedbackGroupId!: number | null

  @Prop() flowOptions!: Array<SelectOptionData>

  @Prop() getFlowPreview!: (key: string) => string

  @Prop() emptyFlowButtonCallback!: () => void

  @Prop() board!: { title: string, board: string }

  @Prop() buttons!: Array<AvailableButtonsTypes>

  @Prop() editorButtonsHelpView!: VueComponent | string

  @Prop({ type: String, required: true }) prefix!: string

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  @Prop({ default: null }) placeholders!: PlaceholdersOnes | PlaceholdersStack

  @Prop() permittedActionTypes!: Array<ActionType>

  @Prop() adminList!: Array<SelectOptionData>

  @Prop() bindTargetByCode!: (args: BindTargetByCode) => Promise<BindTargetByCodeRes | void>

  @Prop() unbindGroup!: () => Promise<void>

  actionTypeAlias: ActionType = 'none'

  @Watch('action', { deep: true })
  onActionChange(value: UserActivationAction) {
    if (
      value &&
      (
        (value.type === UserActivationActionTypeEnum.Flow && value.flow === null) ||
        (value.type === UserActivationActionTypeEnum.Message && !value.variants.length)
      )
    ) {
      this.actionTypeChange('none')
    }
  }

  @Watch('feedbackGroupId')
  onFeedbackGroupID(value: number | string | null) {
    if (value === null) {
      this.actionTypeChange('none')
    }
  }

  get actionTypeAlertMessageKey() {
    return `${ this.prefix }select_${ snakeCase(this.actionTypeAlias) }_action_type_alert`
  }

  get fieldTitles() {
    const baseKey = `field_${ this.prefix }`
    const params = { bot: this.board.title }

    return {
      'title': this.$t(`${ baseKey }title`, params),
      'help-message': this.$te(`${ baseKey }help_message`) ? this.$t(`${ baseKey }help_message`, params) : null,
      'mini-help-message': this.$te(`${ baseKey }mini_help_message`) ? this.$t(`${ baseKey }mini_help_message`, params) : null,
    }
  }

  get actionButtons(): Array<SelectOption> {
    return [
      {
        label: this.$t('activation_action_create_message').toString(),
        value: UserActivationActionTypeEnum.Message
      },
      {
        label: this.$t('activation_action_create_flow').toString(),
        value: UserActivationActionTypeEnum.Flow
      },
      ...this.permittedActionTypes && this.permittedActionTypes.includes('group') ? [ {
        label: this.$t('activation_action_create_admin').toString(),
        value: 'admin'
      },
        {
          label: this.$t('activation_action_create_group').toString(),
          value: 'group'
        } ] : [],
    ]
  }

  unbindGroupConfirm(): void {
    this.$confirm({
      title: this.$t('unbind_group_title').toString(),
      okText: this.$t('accept').toString(),
      cancelText: this.$t('reject').toString(),
      onOk: () => this.unbindGroup(),
    })
  }

  setActionModel(type: ActionType) {
    if (type === UserActivationActionTypeEnum.Message) {
      this.action = getMessageActionTemplate(this.$i18n)
    } else if (type === UserActivationActionTypeEnum.Flow) {
      this.action = getFlowActionTemplate(this.flowOptions[0]?.value ?? '')
    } else {
      this.action = null
    }
  }

  actionTypeChange(value: ActionType): void {
    this.actionTypeAlias = value

    this.setActionModel(value)
  }

  get options(): Array<SelectOption> {
    return [
      ...this.baseActionOptions,
      ...this.permittedActionTypes?.includes('group') ? [ {
        label: this.$t('feedback_bind_group_admin_button_title').toString(),
        value: 'admin'
      } ] : [],
      ...this.permittedActionTypes?.includes('group') ? [ {
        label: this.$t('feedback_bind_group_bind_code_button_title').toString(),
        value: 'group'
      } ] : [],

      ...this.permittedActionTypes?.includes('none') ? [ {
        label: this.$t('bot_feedback_activation_action_data_option_no_action').toString(),
        value: 'none'
      } ] : [],
    ]
  }

  mounted(): void {
    if (this.permittedActionTypes?.includes('group') && this.feedbackGroupId !== null) {
      this.actionTypeAlias = 'group'
    } else {
      this.actionTypeAlias = this.action?.type ?? 'none'
    }
  }
}
